import Actions from "./tipiInterventoActions";
import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import { TipoIntervento } from "../generated";

export class TipiInterventoStore extends AbstractGetAllStore<TipoIntervento> {
    constructor() {
        super(l => l.idTipoIntervento.toString());
        Dispatcher
            .onfunction(Actions.getAll, data => this.setAll(data!))
            ;
    }
}

export default new TipiInterventoStore();